// increment

export function generate_mice(){
  return {
    type:'GENE',
  }
}
export function hit_mice(){
  return {
    type:'HIT',
  }
}
export function miss_mice(){
  return {
    type:'MISS',
  }
}
export function pause(){
  return {
    type:'PAUSE',
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/actionCreators.js
 **/